// extracted by mini-css-extract-plugin
export default {"horizontal":"ald_ald-selection__horizontal__Ze5c3","vertical":"ald_ald-selection__vertical__AaroJ"};